import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ScheduleAccessSection from './components/ScheduleAccessSection';
import NewsSection from './components/NewsSection';
import MapSection from './components/MapSection';
import CTASection from './components/CTASection';
import { updatePageSEO } from '../../utils/seo';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: '岡山市北区の整形外科 | 痛みに寄り添う おかやま整形外科',
      description: '岡山市北区の整形外科クリニック「おかやま整形外科」。スポーツ障害、関節痛、腰痛、骨折治療など、地域の皆様の健康な日常生活をサポート。最新の医療機器と豊富な診療実績で、痛みに寄り添い動ける喜びを取り戻します。完全予約制。086-012-3456',
      keywords: '岡山市 整形外科, 岡山市北区 整形外科, 整形外科 岡山, スポーツ障害 岡山, 関節痛 治療',
      canonical: `${siteUrl}/`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'MedicalOrganization',
        name: 'おかやま整形外科',
        image: `${siteUrl}/logo.png`,
        description: '岡山市北区の整形外科クリニック。スポーツ障害、関節痛、腰痛、骨折治療など、地域の皆様の健康な日常生活をサポート。',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '○○町1-2-3',
          addressLocality: '岡山市北区',
          addressRegion: '岡山県',
          postalCode: '700-0000',
          addressCountry: 'JP'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 34.6617,
          longitude: 133.9350
        },
        telephone: '+81-86-012-3456',
        faxNumber: '+81-86-012-3457',
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '09:00',
            closes: '18:00'
          }
        ],
        priceRange: '¥¥',
        medicalSpecialty: '整形外科',
        foundingDate: '2000',
        employee: {
          '@type': 'Person',
          name: '岡山花子',
          jobTitle: '院長',
          description: '整形外科専門医'
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <NewsSection />
        <FeaturesSection />
        <ScheduleAccessSection />
        <CTASection />
      </main>
      <MapSection />
      <Footer />
    </div>
  );
};

export default HomePage;
